import { useNavigate } from "react-router-dom";
import { Button, Tag } from "@/frontend/components/common";
import { FaArrowLeft, FaTrophy, FaCalendarAlt } from "react-icons/fa";
import type { TournamentResponseDTO } from "@/shared/dto";
import type { SeasonInfo } from "../types";

interface TournamentHeaderProps {
  tournament: TournamentResponseDTO;
  currentSeason?: SeasonInfo;
}

export function TournamentHeader({
  tournament,
  currentSeason,
}: TournamentHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-r from-slate-800 to-slate-700 rounded-xl p-6 shadow-lg">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate("/tournaments")}
            className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors text-white"
          >
            <FaArrowLeft size={18} />
          </button>
          <div className="flex items-center gap-4">
            {tournament.logo ? (
              <img
                src={tournament.logo}
                alt={tournament.name}
                className="w-16 h-16 rounded-lg object-cover border-2 border-white/20"
              />
            ) : (
              <div className="w-16 h-16 rounded-lg bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center">
                <FaTrophy className="text-white text-2xl" />
              </div>
            )}
            <div>
              <h1 className="text-2xl font-bold text-white">
                {tournament.name}
              </h1>
              <div className="flex items-center gap-2 mt-1">
                {tournament.country && (
                  <span className="text-slate-300 text-sm flex items-center gap-1">
                    {tournament.country.flag && (
                      <img
                        src={tournament.country.flag}
                        alt=""
                        className="w-4 h-4"
                      />
                    )}
                    {tournament.country.name}
                  </span>
                )}
                {tournament.discipline && (
                  <Tag color="blue" className="!m-0">
                    {tournament.discipline.name}
                  </Tag>
                )}
                {currentSeason?.format && (
                  <Tag color="purple" className="!m-0">
                    {currentSeason.format.name}
                  </Tag>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {currentSeason && (
        <div className="mt-4 pt-4 border-t border-white/10">
          <div className="flex items-center gap-4 text-white/80">
            <FaCalendarAlt />
            <span className="font-medium">Periodo:</span>
            <span className="text-white font-bold">
              {currentSeason.start || currentSeason.end ? (
                <>
                  {currentSeason.start &&
                    new Date(currentSeason.start).toLocaleDateString("es-ES")}
                  {currentSeason.start && currentSeason.end && " — "}
                  {currentSeason.end &&
                    new Date(currentSeason.end).toLocaleDateString("es-ES")}
                </>
              ) : (
                currentSeason.season
              )}
            </span>
            {currentSeason.status && (
              <Tag
                color={currentSeason.status.color || "default"}
                className="!m-0"
              >
                {currentSeason.status.name}
              </Tag>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
